import { render, staticRenderFns } from "./MostOccurredLoading.vue?vue&type=template&id=961ec3d8&scoped=true"
import script from "./MostOccurredLoading.vue?vue&type=script&lang=js"
export * from "./MostOccurredLoading.vue?vue&type=script&lang=js"
import style0 from "./MostOccurredLoading.vue?vue&type=style&index=0&id=961ec3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ec3d8",
  null
  
)

export default component.exports